const AllWD = (props) => (
  <svg width='22.159' height='7.386' viewBox='0 0 22.159 7.386' fill='#fff' {...props}>
    <path
      d='M2061.233,760.607h-.822v1.563h-1.4v-1.563h-2.876V759.36l2.671-4.41h1.6v4.54h.822Zm-2.22-1.117v-3.13l-1.813,3.13Z'
      transform='translate(-2056.137 -754.785)'
    />
    <path
      d='M2129.766,752.819l.975,4.23.212,1.177.213-1.153.834-4.254h1.629l.877,4.229.225,1.178.228-1.132.985-4.275h1.572l-2.078,7.386h-1.478l-.892-4.32-.26-1.428-.261,1.428-.892,4.32h-1.433l-2.094-7.386Z'
      transform='translate(-2122.542 -752.819)'
    />
    <path
      d='M2265.487,752.979a2.439,2.439,0,0,1,1.259.937,3.286,3.286,0,0,1,.527,1.193,5.712,5.712,0,0,1,.14,1.223,4.907,4.907,0,0,1-.592,2.5,2.671,2.671,0,0,1-2.477,1.378h-3.185v-7.386h3.185A3.89,3.89,0,0,1,2265.487,752.979Zm-2.83,1.122v4.821h1.426a1.539,1.539,0,0,0,1.526-1.077,3.8,3.8,0,0,0,.236-1.408,3.463,3.463,0,0,0-.354-1.731,1.494,1.494,0,0,0-1.408-.6Z'
      transform='translate(-2245.254 -752.819)'
    />
  </svg>
)

export default AllWD
